import React, {useState} from 'react'
export default function ABC(){
  const [ABC, setABC] = useState('')
  const [DEF, setDEF] = useState(false)
  const [GHI, setGHI] = useState('')
  const JKL = (e) => {
    e.preventDefault()
    setGHI('')
    var regExScan = new RegExp("^([A-Z]{1}[a-z]{1,30}[- ]{0,1}[A-Z]{1}[a-z]{1,30}[2]{0,1})$")
    if (!regExScan.test(ABC)){
      setGHI('Input Error. Please check your input.')
    }else{
      setDEF(true)
    }
  }
  return (
    <>
    <div className='text-xs mb-2'>
    <div className='flex'>· <u className='ml-1'>F</u>irstname<div className='bg-yellow-200 w-[4px] h-[12px] mt-auto mb-auto'> </div><u>L</u>astname</div>
    · no special characters except -<br/>
    · Use 2 after name if already your name exsited in database. Ex. Don Joe2</div>
    <form className='flex-col flex text-xs' onSubmit={JKL}>
      <label className='text-left'>Fullname</label>
      <input type='text' placeholder='Don Joe' className={`border w-[120px] ${GHI==''?'border-gray-950':'border-red-600'}`} onChange={e=> setABC(e.target.value)} maxlength={10} />
      {!(/^([A-Z]{1}[a-z]{1,30}[- ]{0,1}[A-Z]{1}[a-z]{1,30}[2]{0,1})$/.test(ABC))&& ABC.length>0?<span className='error-msg'>Full name should be in right format. Example: Firstname Lastname</span>:''}
      <button className='primary-btn text-xs w-fit mt-1' disabled={!(ABC.length>0)}>Submit</button>
      {GHI==''&&DEF?<div className='text-xs'>You have successfully submited.</div>:<div className='error-msg'>{GHI}</div>}
    </form> 
    </>
  )
}